module.exports = __webpack_public_path__ + "img/stamp_mailbox.aa817d50.svg";